module.exports = __webpack_public_path__ + "static/media/pl.92cac6ec.jpg";